import { Dispatch, SetStateAction, useContext, useState } from 'react';
import { GenericDrawer } from '@dealstack/frontend/shared/components/GenericDrawer/GenericDrawer';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { DrawerBody } from './DrawerBody';
import { EditDocument } from './types';
import { DocumentFormAction } from '@dealstack/shared/lib/generated';
import { DealContext } from '@dealstack/frontend/app/pages/Project/DealDashboard/DealContext';
import { TableOperations } from '@dealstack/frontend/shared/components/Table/MantineTable/useMantineTableWithPaginationFilteringSorting';
import { DocumentFieldFilter } from '@dealstack/frontend/shared/dataExchange/services/shared/types';

interface Props {
	setEditDocument: Dispatch<SetStateAction<EditDocument>>;
	editDocument: EditDocument;
	dataOperations?: TableOperations<DocumentFieldFilter>;
}

export const DocumentDrawer = ({ setEditDocument, editDocument, dataOperations }: Props) => {
	// maybe need to refactor this out so we can use it in the document library
	const { dealId } = useContext(DealContext);
	const tCapManage = useTranslationCapManage();
	const [editFieldKey, setEditFieldKey] = useState('');
	const [fieldAction, setFieldAction] = useState<DocumentFormAction | null>(null);

	const handleClose = () => {
		setEditDocument({ documentId: '' });
		setEditFieldKey('');
		setFieldAction(null);
	};

	return (
		<GenericDrawer
			onClose={handleClose}
			opened={!!editDocument.documentId}
			title={tCapManage('documents.transactions.side-bar.header')}
			body={DrawerBody({
				editDocument,
				dealId,
				editFieldKey,
				setEditFieldKey,
				fieldAction,
				setFieldAction,
				dataOperations,
			})}
		/>
	);
};
